var appRenameFixed = (function () {
    function appRenameFixed() {
        this.originNames = ["影响力", "协作", "打造高效团队", "授权"];
        this.newNames = ["赢得认同", "建立伙伴关系", "建立成功团队", "敬请期待"];
    }
    //获取要显示的名称
    appRenameFixed.prototype.getShowName = function (originName) {
        //特殊情况
        if (sessionStorage.getItem("CID") == "1") {
            var index = this.originNames.indexOf(originName);
            if (index < 0) {
                return originName;
            }
            else {
                return this.newNames[index];
            }
        }
        else {
            return originName;
        }
    };
    return appRenameFixed;
}());
export { appRenameFixed };



// WEBPACK FOOTER //
// ./src/app/appRenameFixed.ts.pre-build-optimizer.js